import configStore from '~/shared/store/configStore';
import {setStore} from '~/shared/store';

const store = configStore();

setStore(store);

export default store;
